var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import sessionStorageHelper from "./sessionStorageHelper.js";
import { interactionCodeFlow } from "./interactionCodeFlow.js";
import { FORMS } from "../ion/RemediationConstants.js";
import transformIdxResponse from "../ion/transformIdxResponse.js";
function updateAppState(appState, idxResponse) {
  return __async(this, null, function* () {
    const settings = appState.settings;
    const lastResponse = appState.get("idx");
    const useInteractionCodeFlow = settings.get("oauth2Enabled");
    if (useInteractionCodeFlow) {
      if (idxResponse.interactionCode) {
        sessionStorageHelper.removeStateHandle();
        const tokens = yield interactionCodeFlow(settings, idxResponse);
        appState.unset("currentFormName", {
          silent: true
        });
        return tokens;
      }
    } else {
      if (lastResponse) {
        var _idxResponse$context;
        sessionStorageHelper.setStateHandle(idxResponse === null || idxResponse === void 0 ? void 0 : (_idxResponse$context = idxResponse.context) === null || _idxResponse$context === void 0 ? void 0 : _idxResponse$context.stateHandle);
      }
      if (appState.get("currentFormName") === FORMS.CANCEL_TRANSACTION) {
        sessionStorageHelper.removeStateHandle();
      }
    }
    const ionResponse = transformIdxResponse(settings, idxResponse, lastResponse);
    yield appState.setIonResponse(ionResponse);
  });
}
export { updateAppState };
